import secureLocalStorage from "react-secure-storage";
import * as moment from "moment";
import Api from "./Api";
import { toastr } from "react-redux-toastr";

class EmailService {
  /**
   * Converts a data URL to a File object
   * @param {string} dataurl - The data URL to convert
   * @param {string} filename - The name of the file to create
   * @returns {File} - The created File object
   */
  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  /**
   * Sends an email with a chart attachment
   * @param {string} dataURL - The data URL of the chart
   * @param {number} widgetId - The ID of the widget
   * @param {string} emailId - The email address to send to
   * @param {string} message - The message to include in the email
   * @param {string} fileName - The name of the file to attach
   * @returns {Promise} - A promise that resolves when the email is sent
   */
  async sendChartEmail(dataURL, widgetId, emailId, message, fileName) {
    try {
      const CreatedDate = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");
      
      var file = this.dataURLtoFile(dataURL, fileName);
      var fd = new FormData(document.forms[0]);
      fd.append("file", file);
      fd.append("mailId", emailId);
      fd.append("message", message);
      fd.append("widgetId", widgetId);
      fd.append("createdby", parseInt(secureLocalStorage.getItem("loginUserId")));
      fd.append("CreatedDate", CreatedDate);
      fd.append("name", secureLocalStorage.getItem("userName"));
      fd.append("TenantKey", secureLocalStorage.getItem("tenantKey"));
      
      let response = await Api.shareWidgetToUser(fd);
      
      if (response.status === 200) {
        toastr.success(response.message);
        return true;
      } else {
        toastr.error(response.message);
        return false;
      }
    } catch (err) {
      console.error(err);
      toastr.error("Failed to send email");
      return false;
    }
  }
}

export default new EmailService();